import { useMutation } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";

export const reactToPost = async (data) => {
  const body = new FormData();

  body.append(
    "dados",
    `[${JSON.stringify({
      postagemid: data.postId,
      alunoid: _cookies.getItem("auth").user.alunoid,
      reacao: data.reaction,
    })}]`
  );
  const res = await axios.middleware.post(
    "/aluno.asmx/Marcar_Reacao_Postagem",
    body
  );
};

export const useReactToPost = ({ config } = {}) => {
  return useMutation({ ...config, mutationFn: reactToPost });
};
